import { create } from "zustand";
import { Branding } from "../services/swagger";

interface BrandingStore {
  branding: Branding;
  setBranding: (values: Branding) => void;
  resetBranding: () => void;
}

const defaultBranding: Branding = {
  domain: "ticketsystem",
  name: "Ticket Support System",
  shortname: "Support",
  title: "Support",
  description:
    "Create a support ticket by signing in or creating an account. You can also send your issue through email on support@akcaba.com.",
  whatWeDo:
    "We provide efficient and reliable support to help you resolve issues quickly. Our team is dedicated to ensuring a smooth experience by responding to your requests, troubleshooting problems, and offering clear solutions to keep your systems and services running seamlessly.",
  logo: { image: "", link: "" },
  favicon: "",
  links: {
    website: { label: "Website", link: window.location.origin },
    facebook: { label: "Facebook", link: "https://facebook.com" },
    instagram: { label: "Instagram", link: "https://instagram.com" },
    linkedin: { label: "Linkedin", link: "https://linkedin.com" },
    x: { label: "X (Twitter)", link: "https://x.com" },
    youtube: { label: "Youtube", link: "https://youtube.com" },
  },
  contact: {
    email: "contact@email.com",
    phone: "",
    address: "",
    whatsapp: "",
    whatsappLabel: "WhatsApp",
    mapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1027384.4989981633!2d32.76582225625454!3d35.16813647000648!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14de1767ca494d55%3A0x324c3c807fc4146e!2sCyprus!5e1!3m2!1sen!2s!4v1761901651656!5m2!1sen!2s",
  },
  themeColor: "",
};

const initialBranding: Branding = localStorage.getItem("branding")
  ? JSON.parse(localStorage.getItem("branding")!)
  : defaultBranding;

export const useBrandingStore = create<BrandingStore>((set) => ({
  branding: initialBranding,
  setBranding: (values: Branding) => {
    set(() => ({ branding: values }));
    localStorage.setItem("branding", JSON.stringify(values));
  },
  resetBranding: () => {
    set(() => ({ branding: defaultBranding }));
    localStorage.removeItem("branding");
  },
}));
